//
import { Fragment } from "react";

import { useTheme } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { alpha, darken, lighten } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import OmniAvatar from "./omniAvatar";

const SymptomListItem = props => {
  const { symptom, index = 0, onClickHandler = null } = props;
  const theme = useTheme();

  const getSecondaryText = theSymptom => {
    if (theSymptom.timeSeries.length === 0) {
      return "Click To Start Tracking";
    } else if (theSymptom.description != null && theSymptom.description !== "") {
      return theSymptom.description;
    } else {
      return `${theSymptom.timeSeries.length} entries`;
    }
  };

  const getSymptomPrimaryColor = theSymptom => {
    if (symptom.timeSeries.length === 0) {
      return theme.palette.info.main;
    } else if (
      symptom.timeSeries.length > 0 &&
      symptom.timeSeries[symptom.timeSeries.length - 1].value >= 7
    ) {
      return theme.palette.error.main;
    } else if (
      symptom.timeSeries.length > 0 &&
      symptom.timeSeries[symptom.timeSeries.length - 1].value > 3 &&
      symptom.timeSeries[symptom.timeSeries.length - 1].value < 7
    ) {
      return theme.palette.warning.main;
    } else if (
      symptom.timeSeries.length > 0 &&
      symptom.timeSeries[symptom.timeSeries.length - 1].value <= 3
    ) {
      return theme.palette.success.main;
    } else {
      return theme.palette.secondary.main;
    }
  };

  return (
    <ListItem
      dense
      key={index}
      disableGutters={true}
      onClick={() => {
        onClickHandler(symptom); //just does all
      }}
      sx={[
        {
          padding: theme.spacing(1),
          paddingTop: 0,
          paddingBottom: 0,
          marginBottom: theme.spacing(1),
          borderRadius: theme.spacing(1),
          boxShadow: theme.shadows[3],
        },
        {
          backgroundColor: alpha(getSymptomPrimaryColor(symptom), 0.75),
          "&:hover": {
            backgroundColor: alpha(getSymptomPrimaryColor(symptom), 0.5),
            cursor: "pointer",
          },
        },
      ]}
    >
      <Tooltip title="Last Value" placement="top">
        <OmniAvatar
          sx={[
            {
              width: 42,
              height: 42,
              fontSize: "1.8rem",
              boxShadow: theme.shadows[3],
            },
            {
              color: darken(getSymptomPrimaryColor(symptom), 0.5),
              backgroundColor: lighten(getSymptomPrimaryColor(symptom), 0.5),
              border: `2px solid ${darken(getSymptomPrimaryColor(symptom), 0.5)}`,
            },
          ]}
        >
          {symptom.timeSeries.length === 0
            ? "?"
            : symptom.timeSeries[symptom.timeSeries.length - 1].value}
        </OmniAvatar>
      </Tooltip>
      <ListItemText
        primary={
          <Typography
            component="span"
            variant="h6"
            sx={{
              display: "flex",
              flexDirection: "column",
              marginLeft: theme.spacing(1),
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              marginTop: 0,
              color: theme.palette.commonground.contrastText,
              webkitUserSelect: "none",
              userSelect: "none",
            }}
          >
            {symptom.name}
          </Typography>
        }
        secondary={
          <Fragment>
            <Typography
              component="span"
              variant="subtitle2"
              color="textPrimary"
              sx={{
                display: "flex",
                flexDirection: "row",
                marginLeft: theme.spacing(1),
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                marginTop: "-6px",
                color: theme.palette.commonground.contrastText,
                webkitUserSelect: "none",
                userSelect: "none",
              }}
            >
              {getSecondaryText(symptom)}
            </Typography>
          </Fragment>
        }
      />
      {/* 
      make this a notification to click to update.
      
      <Tooltip title={"Details"} placement="left">
        <IconButton
          sx={[
            {
              position: "absolute",
              top: theme.spacing(1.25),
              right: theme.spacing(1),
              height: 42,
              width: 42,
              borderRadius: "50%",
              border: `2px solid ${darken(getSymptomPrimaryColor(symptom), 0.5)}`,
              "&:hover": {
                color: darken(getSymptomPrimaryColor(symptom), 0.5),
                backgroundColor: lighten(getSymptomPrimaryColor(symptom), 0.5),
                border: `2px solid ${darken(getSymptomPrimaryColor(symptom), 0.5)}`,
              },
            },
          ]}
          size="large"
          onClick={e => {
            e.stopPropagation();
            onClickHandler(symptom);
          }}
        >
          <EditIcon sx={{ height: 28, width: 28 }} />
        </IconButton>
      </Tooltip> */}
    </ListItem>
  );
};

export default SymptomListItem;
